/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as r from "react";
import n from "prop-types";
import { memoizeOne as H, getNestedValue as x, validatePackage as X, noop as A, canUseDOM as Y, getter as Z, classNames as ee } from "@progress/kendo-react-common";
import { readColumns as te, mapColumns as oe, tableKeyboardNavigation as R, getSelectionOptions as K, CommonDragLogic as se, ColumnResize as ne, TableKeyboardNavigationContext as O, tableKeyboardNavigationTools as P, Header as ae, HeaderRow as ie, tableColumnsVirtualization as le, tableKeyboardNavigationScopeAttributes as re, TableSelection as he, tableKeyboardNavigationBodyAttributes as de, DropClue as ce, DragClue as pe, flatData as ge, FilterRow as ue } from "@progress/kendo-react-data-tools";
import { setHeaderRowsTop as me, tableRowsVirtualization as fe } from "./utils/index.mjs";
import { TreeListCell as Ce } from "./cells/TreeListCell.mjs";
import { TreeListNoRecords as ve } from "./TreeListNoRecords.mjs";
import { TreeListRow as be } from "./rows/TreeListRow.mjs";
import { packageMetadata as Se } from "./package-metadata.mjs";
const k = class k extends r.Component {
  constructor(h) {
    super(h), this.wrapperScrollLeft = 0, this.wrapperScrollTop = 0, this.updateOnScroll = !1, this.tbodyOffsetTop = 0, this.prevData = [], this.flattedData = [], this.extendedColumn = [], this.columnsMap = [], this.element = null, this.contextStateRef = { current: void 0 }, this.navigationStateRef = { current: void 0 }, this.scrollIntoView = (e) => {
      if (!this.element)
        return;
      const { rowIndex: t = 0 } = e, { scrollable: o, rowHeight: s = 0 } = this.props;
      if (o === "virtual" || s)
        this.element.scroll(0, (t - 1) * s);
      else {
        const l = this.element.querySelector(`tbody > tr:nth-child(${t})`);
        if (l) {
          const i = l.offsetTop - this.tbodyOffsetTop;
          this.element.scroll(0, i);
        }
      }
    }, this.getExtendedColumn = H(
      (e, t) => te(e, { prevId: 0, idPrefix: t })
    ), this.getColumnsMap = H(
      (e, t) => oe(e, t)
    ), this.onKeyDown = (e) => {
      if (R.onKeyDown(e, {
        contextStateRef: this.contextStateRef,
        navigationStateRef: this.navigationStateRef
      }), this.props.onKeyDown) {
        const { mode: t, cell: o } = K(this.props.selectable), s = {
          dataItems: this.getLeafDataItems(),
          mode: t,
          cell: o,
          componentId: this._treeListId,
          selectedField: this.props.selectedField,
          ...this.getArguments(e)
        };
        this.props.onKeyDown.call(void 0, s);
      }
    }, this.onFocus = (e) => {
      R.onFocus(e, {
        contextStateRef: this.contextStateRef
      });
    }, this.onRowDrag = (e) => {
      this.props.onRowDrag && this.props.onRowDrag.call(void 0, { ...e, target: this });
    }, this.onRowDrop = (e) => {
      this.props.onRowDrop && this.props.onRowDrop.call(void 0, { ...e, target: this });
    }, this.columnReorder = (e, t, o) => {
      const s = this.extendedColumn[e].depth, l = (c) => {
        do
          c++;
        while (c < this.extendedColumn.length && this.extendedColumn[c].depth > s);
        return c;
      }, i = this.extendedColumn.splice(e, l(e) - e);
      if (this.extendedColumn.splice(e < t ? l(t - i.length) : t, 0, ...i), this.extendedColumn.filter((c) => c.declarationIndex >= 0).forEach((c, g) => c.orderIndex = g), this.props.onColumnReorder) {
        const c = {
          target: this,
          columns: this.columns,
          nativeEvent: o
        };
        this.props.onColumnReorder.call(void 0, c);
      }
    }, this.onResize = (e, t, o, s, l) => {
      if (this.props.onColumnResize) {
        const i = this.extendedColumn.filter((g) => g.children.length === 0).reduce((g, m) => g += parseFloat(String(m.width)), 0), c = {
          columns: this.columns,
          totalWidth: i,
          index: e,
          nativeEvent: s,
          newWidth: t,
          oldWidth: o,
          end: l,
          target: this
        };
        this.props.onColumnResize.call(void 0, c);
      }
    }, this.handleOnScroll = (e) => {
      const t = e.currentTarget.scrollLeft, o = e.currentTarget.scrollTop, { columnVirtualization: s, scrollable: l, rowHeight: i = 0 } = this.props, c = i, g = 0;
      let m = !1;
      s && Math.abs(this.wrapperScrollLeft - t) > g && (this.wrapperScrollLeft = t, m = !0), l === "virtual" && Math.abs(this.wrapperScrollTop - o) > c && (this.wrapperScrollTop = o, m = !0), m && (this.updateOnScroll = !0, this.forceUpdate());
    }, this.calculateSizes = (e) => {
      if (!e || this.props.scrollable === "none")
        return;
      const t = Array.from(e.childNodes), o = t.find((i) => i.nodeName === "TABLE"), s = this.props.toolbar && t.find((i) => i.nodeType === 1 && i.classList.contains("k-grid-toolbar"));
      let l = 0;
      if (s) {
        const i = s.style.boxSizing;
        s.style.boxSizing = "border-box", l = parseFloat(String(window.getComputedStyle(s).height)) || s.offsetHeight, s.style.boxSizing = i, s.getAttribute("style") || s.removeAttribute("style");
      }
      this.tbodyOffsetTop = o.tBodies[0].offsetTop, me(o, l);
    }, this.itemChange = (e) => {
      const t = this.props.onItemChange;
      if (e.field === this.props.expandField) {
        const o = this.props.onExpandChange;
        if (o) {
          const s = {
            ...this.getArguments(e.syntheticEvent),
            dataItem: e.dataItem,
            level: e.level,
            value: e.value
          };
          o.call(void 0, s);
        }
        return;
      }
      if (t) {
        const o = {
          ...this.getArguments(e.syntheticEvent),
          dataItem: e.dataItem,
          level: e.level,
          field: e.field,
          value: e.value
        };
        t.call(void 0, o);
      }
    }, this.onHeaderSelectionChange = (e) => {
      if (this.props.onHeaderSelectionChange) {
        const t = {
          field: e.field,
          nativeEvent: e.syntheticEvent && e.syntheticEvent.nativeEvent,
          syntheticEvent: e.syntheticEvent,
          target: this,
          dataItems: this.getLeafDataItems()
        };
        this.props.onHeaderSelectionChange.call(void 0, t);
      }
    }, this.selectionRelease = (e) => {
      if (this.props.onSelectionChange) {
        const t = {
          syntheticEvent: void 0,
          target: this,
          selectedField: this.props.selectedField || "",
          componentId: this._treeListId,
          dataItems: this.getLeafDataItems(),
          dataItem: null,
          level: [],
          ...e
        };
        this.props.onSelectionChange.call(void 0, t);
      }
    }, this.sortChange = (e, t, o) => {
      this.raiseDataEvent(this.props.onSortChange, { sort: t, field: o }, e);
    }, this.headerFilterChange = (e, t, o) => {
      this.raiseDataEvent(this.props.onFilterChange, { filter: t, field: o }, e);
    }, this.filterChange = (e) => {
      const { filter: t, field: o } = e;
      this.raiseDataEvent(this.props.onFilterChange, { filter: t, field: o }, e.syntheticEvent);
    }, this.columnMenuFilterChange = (e, t, o) => {
      const { onColumnMenuFilterChange: s } = this.props;
      if (!s)
        return;
      const l = {
        syntheticEvent: e,
        filter: t,
        field: o,
        target: this,
        nativeEvent: e.nativeEvent
      };
      s.call(void 0, l);
    }, this.expandChange = (e, t, o) => {
      const { expandField: s, onExpandChange: l } = this.props;
      if (s && l) {
        const i = {
          ...this.getArguments(e),
          dataItem: t,
          level: o,
          value: this.expanded(t)
        };
        l.call(void 0, i);
      }
    }, this.rowClick = (e, t) => {
      if (this.props.onRowClick && e.target.nodeName === "TD") {
        const o = {
          dataItem: t.dataItem,
          level: t.level,
          ...this.getArguments(e)
        };
        this.props.onRowClick.call(void 0, o);
      }
    }, this.rowDoubleClick = (e, t) => {
      if (this.props.onRowDoubleClick && e.target.nodeName === "TD") {
        const o = {
          dataItem: t.dataItem,
          level: t.level,
          ...this.getArguments(e)
        };
        this.props.onRowDoubleClick.call(void 0, o);
      }
    }, this.rowContextMenu = (e, t) => {
      if (this.props.onRowContextMenu && e.target.nodeName === "TD") {
        const o = {
          dataItem: t.dataItem,
          level: t.level,
          ...this.getArguments(e)
        };
        this.props.onRowContextMenu.call(void 0, o);
      }
    }, this.onPageChange = (e) => {
      if (this.props.onPageChange) {
        const t = {
          ...this.getArguments(e.syntheticEvent),
          skip: e.skip,
          take: e.take
        };
        this.props.onPageChange.call(void 0, t);
      }
    }, this.expandedSubItems = (e) => {
      const t = [];
      return this.expanded(e) && this.hasChildren(e) && t.push(...x(this.props.subItemsField, e)), t;
    }, this.getLeafDataItems = () => this.flatData.map((e) => e.dataItem), this.expanded = (e) => !!x(this.props.expandField, e), this.hasChildren = (e) => !!x(this.props.subItemsField, e), X(Se), this.dragLogic = new se(this.columnReorder, A, A), this.columnResize = new ne(this.onResize.bind(this)), R.onConstructor({
      navigatable: !!h.navigatable,
      contextStateRef: this.contextStateRef,
      navigationStateRef: this.navigationStateRef
    });
  }
  get _treeListId() {
    return this.props.id + "-treelist";
  }
  get document() {
    if (Y)
      return this.element && this.element.ownerDocument || document;
  }
  /**
   * @hidden
   */
  componentDidMount() {
    this.calculateSizes(this.element), R.onComponentDidMount({
      scope: this.element || void 0,
      contextStateRef: this.contextStateRef,
      navigationStateRef: this.navigationStateRef
    });
  }
  /**
   * @hidden
   */
  getSnapshotBeforeUpdate() {
    return R.onGetSnapshotBeforeUpdate({
      document: this.document,
      contextStateRef: this.contextStateRef,
      navigationStateRef: this.navigationStateRef
    }), null;
  }
  /**
   * @hidden
   */
  componentDidUpdate(h) {
    h.columns !== this.props.columns && this.calculateSizes(this.element), R.onComponentDidUpdate({
      scope: this.element || void 0,
      contextStateRef: this.contextStateRef,
      navigationStateRef: this.navigationStateRef
    });
  }
  /**
   * @hidden
   */
  componentWillUnmount() {
    this.columnsMap = [], this.prevData = [], this.flattedData = [], this.updateOnScroll = !1, this.getExtendedColumn.clear(), this.getColumnsMap.clear();
  }
  /**
   * @hidden
   */
  render() {
    const {
      columns: h = [],
      filterRow: e,
      scrollable: t = "scrollable",
      resizable: o = !1,
      reorderable: s = !1,
      skip: l,
      take: i
    } = this.props, c = h.some((a) => !!a.filter || !!a.filterCell) || e !== void 0, g = e || ue, m = P.getIdPrefix(this.navigationStateRef), F = this.getExtendedColumn(h, m), T = F.length !== this.extendedColumn.length;
    this.extendedColumn = F, this.columnsMap = this.getColumnsMap(this.extendedColumn, T);
    const f = this.extendedColumn.filter((a) => a.children.length === 0);
    this.columnResize.columns = this.extendedColumn, this.columnResize.resizable = o, this.dragLogic.columns = this.extendedColumn, this.dragLogic.reorderable = s, this.dragLogic.groupable = !1;
    const y = /* @__PURE__ */ r.createElement(
      ae,
      {
        headerRow: /* @__PURE__ */ r.createElement(
          ie,
          {
            sort: this.props.sort,
            sortable: this.props.sortable,
            sortChange: this.sortChange,
            selectionChange: this.onHeaderSelectionChange,
            columns: this.extendedColumn,
            columnsMap: this.columnsMap,
            cellRender: this.props.headerCellRender,
            columnResize: this.columnResize,
            columnMenu: this.props.columnMenu,
            columnMenuFilter: this.props.columnMenuFilter,
            columnMenuFilterChange: this.columnMenuFilterChange,
            pressHandler: this.dragLogic.pressHandler,
            dragHandler: this.dragLogic.dragHandler,
            releaseHandler: this.dragLogic.releaseHandler,
            filterChange: this.headerFilterChange
          }
        ),
        filterRow: c && /* @__PURE__ */ r.createElement(
          g,
          {
            columns: f,
            filter: this.props.filter,
            filterChange: this.filterChange,
            sort: this.props.sort,
            ariaRowIndex: this.columnsMap.length + 1
          }
        ) || void 0,
        columnResize: this.columnResize
      }
    ), z = this.props.style || {}, { colSpans: V, hiddenColumns: U } = le({
      enabled: this.props.columnVirtualization,
      columns: f,
      scrollLeft: this.wrapperScrollLeft,
      tableViewPortWidth: parseFloat((z.width || "").toString())
    }), $ = (a, u, D, I, E, w) => f.map((d, p) => {
      if (U[p])
        return null;
      const b = d.id ? d.id : p, M = `${d.className ? d.className + " " : ""}${d.locked ? "k-grid-content-sticky" : ""}`, S = {
        id: P.generateNavigatableId(`${D}-${String(p)}`, m),
        colSpan: V[p],
        dataItem: a.dataItem,
        field: d.field,
        format: d.format,
        className: M || void 0,
        render: this.props.cellRender,
        onChange: this.itemChange,
        selectionChange: this.props.onSelectionChange ? (v) => {
          this.selectionChange({ event: v, item: a, columnIndex: p, dataIndex: E });
        } : void 0,
        level: a.level,
        expandable: d.expandable,
        expanded: I,
        hasChildren: this.hasChildren(a.dataItem),
        onExpandChange: this.expandChange,
        colIndex: p,
        ariaColumnIndex: d.ariaColumnIndex,
        style: d.left !== void 0 && {
          left: d.left,
          right: d.right,
          borderRightWidth: d.rightBorder ? "1px" : ""
        } || {},
        isSelected: Array.isArray(w) && w.indexOf(p) > -1
      };
      return u && d.editCell ? /* @__PURE__ */ r.createElement(d.editCell, { key: b, ...S, onChange: this.itemChange }) : d.cell ? /* @__PURE__ */ r.createElement(d.cell, { key: b, ...S }) : /* @__PURE__ */ r.createElement(Ce, { key: b, ...S });
    });
    let C = this.flatData;
    const L = C.length;
    l !== void 0 && i !== void 0 && (C = C.slice(l, l + i)), t === "virtual" && (C = fe({
      rows: C,
      tableViewPortHeight: parseFloat((z.height || z.maxHeight || "").toString()),
      scrollTop: this.wrapperScrollTop
    }), this.updateOnScroll = !1);
    const W = C.map((a) => a.level), j = this.columnsMap.length + (c ? 1 : 0) + 1, G = C.length > 0 && C.map((a, u) => {
      const D = x(this.props.editField, a.dataItem), I = this.props.dataItemKey && Z(this.props.dataItemKey)(a.dataItem), E = String(I || a.level.join(".")), w = this.expanded(a.dataItem), d = this.props.selectedField ? x(this.props.selectedField, a.dataItem) : void 0, p = {
        key: E,
        level: a.level,
        levels: W,
        dataItem: a.dataItem,
        selectedField: this.props.selectedField,
        rowHeight: t === "virtual" ? a.height : this.props.rowHeight,
        render: this.props.rowRender,
        onDrop: this.onRowDrop,
        onDrag: this.onRowDrag,
        onClick: (v) => this.rowClick(v, a),
        onDoubleClick: (v) => this.rowDoubleClick(v, a),
        onContextMenu: (v) => this.rowContextMenu(v, a),
        isAltRow: u % 2 !== 0,
        expanded: w,
        rowIndex: u,
        ariaRowIndex: j + u,
        ariaSetSize: a.levelCount,
        ariaPosInSet: a.level[a.level.length - 1] + 1,
        isSelected: typeof d == "boolean" && d
      }, b = this.props.editRow, M = this.props.row || be, S = $(a, D, E, w, u, d);
      return D && b ? /* @__PURE__ */ r.createElement(b, { ...p, key: p.key }, S) : /* @__PURE__ */ r.createElement(M, { ...p, key: p.key }, S);
    }) || /* @__PURE__ */ r.createElement("tr", { className: "k-table-row k-grid-norecords" }, /* @__PURE__ */ r.createElement("td", { colSpan: f.length }, this.props.noRecords || /* @__PURE__ */ r.createElement(ve, null))), _ = (a) => this.props.sort && this.props.sort.some((u) => u.field === a), q = /* @__PURE__ */ r.createElement("colgroup", { ref: (a) => {
      this.columnResize.colGroupMain = a;
    } }, f.map(
      (a, u) => /* @__PURE__ */ r.createElement(
        "col",
        {
          key: u.toString(),
          className: _(a.field) ? "k-sorted" : void 0,
          style: a.width !== void 0 ? { width: a.width } : void 0
        }
      )
    )), J = this.props.columnVirtualization || this.props.scrollable === "virtual", Q = this.props.selectable && this.props.selectable.drag ? "none" : void 0, N = this.props.tableProps || {};
    return /* @__PURE__ */ r.createElement(O.Provider, { value: this.contextStateRef.current }, /* @__PURE__ */ r.createElement(
      "div",
      {
        id: this.props.id,
        style: this.props.style,
        className: ee(
          "k-grid k-grid-md",
          "k-treelist",
          this.props.className,
          { "k-treelist-scrollable": t !== "none" }
        ),
        ref: (a) => this.element = a,
        onScroll: J ? this.handleOnScroll : void 0,
        onKeyDown: this.onKeyDown,
        onFocus: this.onFocus,
        "aria-rowcount": L,
        "aria-colcount": f.length,
        role: "treegrid",
        ...re
      },
      this.props.toolbar,
      /* @__PURE__ */ r.createElement(
        he,
        {
          selectable: this.props.selectable,
          onRelease: this.selectionRelease
        },
        /* @__PURE__ */ r.createElement(
          "table",
          {
            className: "k-table k-table-md k-grid-table",
            ...N,
            style: { ...N.style || {}, userSelect: Q },
            role: "presentation"
          },
          q,
          y,
          /* @__PURE__ */ r.createElement("tbody", { className: "k-table-tbody", ...de, role: "presentation" }, G)
        )
      ),
      this.props.pager && /* @__PURE__ */ r.createElement(
        this.props.pager,
        {
          className: "k-grid-pager",
          total: L,
          skip: l,
          take: i,
          onPageChange: this.onPageChange
        }
      ),
      s && /* @__PURE__ */ r.createElement(r.Fragment, null, /* @__PURE__ */ r.createElement(ce, { ref: this.dragLogic.refDropElementClue }), /* @__PURE__ */ r.createElement(pe, { ref: this.dragLogic.refDragElementClue }))
    ));
  }
  get columns() {
    const h = this.extendedColumn.filter((t) => t.declarationIndex >= 0 && t.parentIndex === -1), e = (t) => (t.sort((o, s) => o.declarationIndex - s.declarationIndex), t.map((o) => {
      const {
        declarationIndex: s,
        parentIndex: l,
        depth: i,
        colSpan: c,
        rowSpan: g,
        index: m,
        kFirst: F,
        groupable: T,
        children: f,
        ...y
      } = o;
      return f.length ? {
        children: e(f),
        ...y
      } : y;
    }));
    return e(h);
  }
  get flatData() {
    const { data: h = [], rowHeight: e = 0 } = this.props;
    let t = 0;
    const o = (l) => {
      const i = { height: e, offsetTop: t };
      return t += i.height, i;
    };
    let s = this.updateOnScroll && this.prevData === h && this.tbodyOffsetTop > 0 && this.flattedData.length ? this.flattedData : ge(h, this.expandedSubItems, o);
    return this.prevData = h, this.flattedData = s, s;
  }
  selectionChange(h) {
    if (this.props.onSelectionChange) {
      const { event: e, item: t, dataIndex: o, columnIndex: s } = h, { mode: l, cell: i } = K(this.props.selectable), c = {
        ...this.getArguments(e.syntheticEvent),
        dataItem: t.dataItem,
        level: t.level,
        startColIndex: s,
        endColIndex: s,
        startRowIndex: o,
        endRowIndex: o,
        dataItems: this.getLeafDataItems(),
        altKey: !1,
        ctrlKey: !1,
        shiftKey: !1,
        metaKey: !1,
        mode: l,
        cell: i,
        isDrag: !1,
        componentId: this._treeListId,
        selectedField: this.props.selectedField || ""
      };
      this.props.onSelectionChange.call(void 0, c);
    }
  }
  raiseDataEvent(h, e, t) {
    const o = this.props.onDataStateChange;
    if (h)
      h.call(void 0, { ...this.getArguments(t), ...e });
    else if (o) {
      const s = {
        ...this.getArguments(t),
        dataState: { ...this.getDataState(), ...e }
      };
      o.call(void 0, s);
    }
  }
  getDataState() {
    return {
      filter: this.props.filter,
      sort: this.props.sort
    };
  }
  getArguments(h) {
    return {
      nativeEvent: h && h.nativeEvent,
      syntheticEvent: h,
      target: this
    };
  }
};
k.propTypes = {
  data: n.array,
  resizable: n.bool,
  reorderable: n.bool,
  sortable: n.oneOfType([
    n.bool,
    n.shape({
      mode: n.oneOf(["single", "multiple"]),
      allowUnsort: n.bool
    })
  ]),
  onSortChange: n.func,
  sort: n.array,
  columns: n.arrayOf(n.object),
  columnVirtualization: n.bool,
  filter: n.array,
  onFilterChange: n.func,
  filterRow: n.any,
  toolbar: n.any,
  noRecords: n.any,
  onExpandChange: n.func,
  expandField: n.string,
  subItemsField: n.string,
  selectedField: n.string,
  onSelectionChange: n.func,
  onHeaderSelectionChange: n.func,
  onRowClick: n.func,
  onItemChange: n.func,
  editField: n.string,
  scrollable: n.oneOf(["none", "scrollable", "virtual"]),
  rowHeight: n.number,
  style: n.object,
  tableProps: n.object,
  pager: n.any,
  skip: n.number,
  take: n.number,
  onPageChange: n.func,
  onDataStateChange: n.func,
  onColumnResize: n.func,
  onColumnReorder: n.func,
  dataItemKey: n.string,
  navigatable: n.bool
}, k.contextType = O;
let B = k;
export {
  B as TreeList
};
